import { _sharedActionsConstantsSW, _sharedActionsSW } from "@/shared/store/sw/actions";
export const swActionConstants = _sharedActionsConstantsSW;
export const swActions = _sharedActionsSW;
